import { IonCard } from '@ionic/react';
import styled from 'styled-components';

export const IonCardFormLogin = styled(IonCard)`
  box-shadow: 11px 1px 24px rgb(0 0 0 / 30%);
  padding-bottom: 15px;
  margin: 0;
`;
